import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearchCSASku } from '../../hooks/useOrders';
import CSAFilteredProductsTable from '../CSAList/CSAFilteredProductsTable';

const CSASkuSearch = () => {
    const [draftSku, setDraftSku] = useState('');
    const [submittedSku, setSubmittedSku] = useState('');
    const [results, setResults] = useState([]);

    const params = submittedSku ? { sku: submittedSku } : null;

    const { isFetching, refetch } = useSearchCSASku(
        params,
        res => {
            const list = res?.data ?? res ?? [];
            setResults(Array.isArray(list) ? list : []);
        },
        err => {
            message.error(err?.response?.data?.message ?? 'Failed to search SKU');
            setResults([]);
        },
    );

    const handleSearch = () => {
        const trimmed = draftSku.trim();
        if (!trimmed) {
            message.warning('Please enter a SKU');
            return;
        }
        if (trimmed === submittedSku) {
            refetch();
        } else {
            setSubmittedSku(trimmed);
        }
    };

    return (
        <div className="csa-sku-search">
            <div
                className="csa-sku-search-toolbar"
                style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'center' }}
            >
                <Input
                    placeholder="Enter SKU"
                    value={draftSku}
                    onChange={e => setDraftSku(e.target.value)}
                    onPressEnter={handleSearch}
                    allowClear
                    className="csa-sku-search-input"
                    style={{ maxWidth: 320 }}
                />
                <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={handleSearch}
                    loading={isFetching}
                >
                    Search
                </Button>
            </div>
            <CSAFilteredProductsTable
                data={results}
                loading={isFetching}
                total={results.length}
                pageNum={1}
                pageSize={results.length || 10}
            />
        </div>
    );
};

export default CSASkuSearch;
